import type { LadderProgram, ProgramCurriculumVersion, ProgramStatus } from '@dosfilos/domain';

/** A program document read from Firestore, as the ladder service reads it.
 *  Shared by the program screen and the ladder view so both place a program
 *  from the same fields. */
export function toLadderProgram(id: string, data: Record<string, unknown>): LadderProgram {
  const stacksOn = data['stacksOnProgramId'];
  const currentCatalogYear = data['currentCatalogYear'];
  return {
    id,
    name: (data['name'] as string | undefined) ?? id,
    status: ((data['status'] as ProgramStatus | undefined) ?? 'active') as ProgramStatus,
    ...(typeof stacksOn === 'string' && stacksOn ? { stacksOnProgramId: stacksOn } : {}),
    ...(typeof currentCatalogYear === 'string' && currentCatalogYear ? { currentCatalogYear } : {}),
    ...(typeof data['durationTerms'] === 'number'
      ? { durationTerms: data['durationTerms'] as number }
      : {}),
    ...(data['enforceStackEntry'] === true ? { enforceStackEntry: true } : {}),
    ...(data['includesStackedPrograms'] === true ? { includesStackedPrograms: true } : {}),
    curriculumVersions:
      (data['curriculumVersions'] as ProgramCurriculumVersion[] | undefined) ?? [],
  };
}
